/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable default-param-last */
/* eslint-disable camelcase */
import { produce } from 'immer';

import MAINTENANCE_ACTION_TYPES from 'actionTypes/maintenance';
import { isDateWithin, timeNow } from 'helpers/day';
import { Custodian, CustodianName, MaintenanceState } from 'types/Maintenance';

const initialState: MaintenanceState = {
  neokredUpi: null,
  neokredImps: null,
  indianBankNeft: null,
  shivalikBankImps: null,
  auBankMaintenance: null,
};

const maintenanceReducer = produce((draft = initialState, action) => {
  switch (action.type) {
    case MAINTENANCE_ACTION_TYPES.FETCH_FIAT_DEPOSIT_ASSETS.SUCCESS: {
      const custodians = action.result.result || [];
      const currentTime = timeNow();
      custodians.forEach((custodian: Custodian) => {
        const { fiat_deposit_custodian, maintenance_config } = custodian;
        if (fiat_deposit_custodian.toLowerCase() === CustodianName.NEOKRED) {
          if (maintenance_config.UPI) {
            draft.neokredUpi = {
              ...maintenance_config.UPI,
              isUnderMaintenance: isDateWithin(
                maintenance_config.UPI.start_time,
                maintenance_config.UPI.end_time,
                currentTime
              ),
            };
          }

          if (maintenance_config.IMPS) {
            draft.neokredImps = {
              ...maintenance_config.IMPS,
              isUnderMaintenance: isDateWithin(
                maintenance_config.IMPS.start_time,
                maintenance_config.IMPS.end_time,
                currentTime
              ),
            };
          }
        } else if (fiat_deposit_custodian.toLowerCase() === CustodianName.INDIAN_BANK) {
          if (maintenance_config.NEFT) {
            draft.indianBankNeft = {
              ...maintenance_config.NEFT,
              isUnderMaintenance: isDateWithin(
                maintenance_config.NEFT.start_time,
                maintenance_config.NEFT.end_time,
                currentTime
              ),
            };
          }
        } else if (fiat_deposit_custodian.toLowerCase() === CustodianName.SHIVALIK_BANK) {
          if (maintenance_config.IMPS) {
            draft.shivalikBankImps = {
              ...maintenance_config.IMPS,
              isUnderMaintenance: isDateWithin(
                maintenance_config.IMPS.start_time,
                maintenance_config.IMPS.end_time,
                currentTime
              ),
            };
          }
        } else if (fiat_deposit_custodian.toLowerCase() === CustodianName.AU_BANK) {
          if (maintenance_config.UPI) {
            draft.auBankMaintenance = {
              ...maintenance_config.UPI,
              isUnderMaintenance: isDateWithin(
                maintenance_config.UPI.start_time,
                maintenance_config.UPI.end_time,
                currentTime
              ),
            };
          }
        }
      });
      break;
    }
    default:
      return draft;
  }
});

export default maintenanceReducer;
